import { IRON, MIST, WHITE_BACKGROUND } from 'styles/Colors';
import LinearProgress from '@mui/material/LinearProgress';
import LockIcon from '@material-ui/icons/Lock';
import PersonaIcon from 'images/RebrandPersona.png';
import React from 'react';

const iconStyle = {
  height: '4.7rem',
  margin: '0'
};

const containerStyle = {
  marginTop: '4.5rem',
  height: '2.5rem',
  position: 'relative',
  color: IRON,
  '.MuiLinearProgress-colorPrimary': {
    backgroundColor: MIST
  },
  '.c-secure': {
    position: 'absolute',
    left: 'calc(50% - 3.35rem - 10px)',
    top: '-4rem',
    fontSize: '16px',
    zIndex: 1
  }
};
const lockStyle = {
  position: 'relative',
  top: '1px',
  left: '-3px',
  width: '14px',
  height: '14px'
};
const iconContainerStyle = {
  position: 'absolute',
  left: 'calc(50% - 2.35rem - 10px)',
  top: '-2.35rem',
  zIndex: 1,
  backgroundColor: WHITE_BACKGROUND
};

export default function ProgressBar({ value, key }) {
  return (
    <div key={key} css={containerStyle}>
      <span className='c-secure'>
        <LockIcon css={lockStyle} />
        Secure Form
      </span>
      <div css={iconContainerStyle}>
        <img src={PersonaIcon} alt='persona' css={iconStyle} />
      </div>
      <LinearProgress variant='determinate' value={value} />
    </div>
  );
}
